
<script>
    export default {
        name: "loadSimId",
        data(){
            return {
                simId: undefined
            }
        },
        methods: {
            loadSimId() {
                if(this.$route.params.simId) {
                    this.simId = Number(this.$route.params.simId);
                }
            }
        }
    }
</script>
